<template>
        <div class="ml-4">
                <h1 class="text-muted mb-4">
                    <vue-fontawesome class="mr-2" icon="bar-chart"></vue-fontawesome>
                    <router-link class="ml-2 text-decoration-none" to="/reports">
                        <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                        Reports
                    </router-link> 
                    / Margins Per User
                </h1>
    
            <section>    
                <div class="d-flex justify-content-between">
                    <div>
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" 
                                    id="pills-home-tab" 
                                    data-toggle="pill" 
                                    href="#pills-home" 
                                    role="tab" 
                                    aria-controls="pills-home" 
                                    aria-selected="true">
                                                            
                                    Graphs
                                </a>
                            </li>                               							
                            <li class="nav-item">
                                <a class="nav-link" 
                                    id="pills-raw-data-tab" 
                                    data-toggle="pill" 
                                    href="#pills-raw-data" 
                                    role="tab" 
                                    aria-controls="pills-raw-data" 
                                    aria-selected="true">
                                                            
                                    Raw Data
                                </a>
                            </li>
                        </ul>                  
                    </div>              
                </div>	
                <div class="d-flex ">                										
                    <div class="form-group d-flex">
                        <label class="p-2">User</label>
                        <select class="form-control" v-model="selected_user">
                                <option :value="index" v-for="(entry,index) in graph_data" :key="index">
                                    {{entry.user.name}}
                                </option>                                
                        </select>
                    </div>                                 
                    <div class="form-group d-flex">
                        <label class="p-2">From:</label>
                        <input type="date" name="bday" max="3000-12-31" 
                        min="1000-01-01" class="form-control" v-model="from_date"> 
                    </div> 
                    <div class="form-group d-flex">
                        <label class="p-2">To:</label>
                        <input type="date" name="bday" max="3000-12-31" 
                        min="1000-01-01" class="form-control" v-model="to_date"> 
                    </div> 
                    <div class="ml-2" @click="getReport()">
                        <button class="btn btn-outline-success">
                            <span v-if = "getting_reports" class="spinner-border spinner-border-sm"></span>
                            Run reports
                        </button>
                    </div>						
                </div>            
                <div class="tab-content" id="pills-tabContent">
                    <div class="mt-4 tab-pane fade show active" 
                        id="pills-home" 
                        role="tabpanel" 
                        aria-labelledby="pills-home-tab">                           
                        <div class="" v-if="user_graph_data">                                
                            <div :style="graphStyling">                                                                
                                <h2>{{user_graph_data.user.name}}</h2>                                
                                <barchart :data="user_graph_data.data" :options="options" class="col-12"/>
                            </div>                                                       
                        </div>                        
                    </div>     
                    <div class="tab-pane fade" 
                        id="pills-raw-data" 
                        role="tabpanel" 
                        aria-labelledby="pills-raw-data-tab">                    
                        <h2 v-if="user_raw_data">{{user_raw_data.user.name}}</h2>
                        <h2 v-else>No user selected</h2>
                        <div class="rounded shadow p-2">                               
                            <section class="mt-3 d-flex bg-light p-2 rounded">                             
                                <div class="dropdown">
                                    <a class="btn btn-outline-success dropdown-toggle" 
                                        href="#" role="button" id="dropdownMenuLink" 
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Filters
                                    </a>                                
                                    <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                        <div class="form-group d-flex justify-content-between">
                                            <label class="p-2">Search</label>
                                            <input type="text" class="col-8 form-control" v-model="search"> 
                                        </div>                                                                               	
                                    </div>
                                </div>
                                <div class="ml-2">
                                    <button class="btn btn-outline-success"
                                        @click="$exportTable('marginsTable','margins.csv')">
                                        Export to CSV
                                    </button>	
                                </div>	
                            </section>                                              
                            <table class="mt-3 table table-borderless" id="marginsTable">
                                <thead>
                                  <tr>                                    
                                    <th scope="col">product</th>
                                    <th scope="col">wholesale margin</th>
                                    <th scope="col">retail margin</th>
                                    <th scope="col">base margin</th>
                                  </tr>
                                </thead>
                                <tbody v-if="user_raw_data">
                                  <tr v-for="(margin,index) in user_raw_data_without_zeroes" :key="index">                                    
                                    <td>{{margin.product.name}}</td>
                                    <td>{{margin.margins.wholesale}}</td>
                                    <td>{{margin.margins.retail}}</td>
                                    <td>{{margin.margins.base_price}}</td>
                                  </tr>   
                                  <tr>                                    
                                        <th>TOTAL</th>
                                        <th>{{total('wholesale') | intcomma}}</th>
                                        <th>{{total('retail') | intcomma }}</th>
                                        <th>{{total('base_price') | intcomma}}</th>
                                    </tr>                                
                                </tbody>
                              </table>
                        </div>
                    </div>                              
                </div>
                
            </section>
        </div>
    </template>
    <script>
import barchart from '@/components/charts/bar.vue'
export default {
    name: 'reportDetail',
    components: {barchart},
    data(){
        return{  
            search: null,         
            selected_user: null, 
            getting_reports:false,
            from_date: null,
            to_date: null,            
            url:null,
            reports:null,
            graphStyling: {
                width: '100%',
                overflowX: 'scroll'
            },
            render_graph: false,
            options:{
                legend: {
                    display: false,
                },
                scales: {
                    xAxes: [{ stacked: true }],
                    yAxes: [{ stacked: true }]
                },
                responsive: true,
                maintainAspectRatio: false
            },
            graph_data:[],
            user_graph_data : null,
            user_raw_data: null
        }
    },
    mounted(){
        this.from_date = this.$moment().subtract(0, 'days').format('YYYY-MM-DD')
        this.to_date = this.$moment().format('YYYY-MM-DD')
        this.getReport()            
    },    
    computed:{
        account_switched(){
            return this.$store.state.account_switch_count
        },
        user_raw_data_without_zeroes(){
            if (this.user_raw_data){
                var margins = this.user_raw_data.margins       

                return margins.filter((margin)=>{
                   return ( parseInt(margin.margins.base_price) !== 0 ||  parseInt(margin.margins.wholesale) !== 0 ||  parseInt(margin.margins.retail) !== 0 )
                })
            }        
            else {
                return null
            }                               
        }
    },
    watch:{
        account_switched: function(){
            this.getReport()
        },
        search:function(){			
            this.$searchTable('marginsTable',this.search)			
        },
        selected_user: function(){
            if(this.selected_user){
                this.user_graph_data = this.graph_data[this.selected_user]
                this.user_raw_data = this.reports.data[this.selected_user]
            }
        },
        reports: function(){            
            if (this.reports){                     
                this.graphStyling.width = "100%"
                this.graph_data = []
                for (var data of this.reports.data){
                    //reset graph data to original
                    let this_graph_data = {
                        labels: [],
                        datasets: [
                        {
                            label: 'Base',
                            data: [],
                            backgroundColor: '#3B9638' // green
                        },
                        {
                            label: 'Wholesale',
                            data: [],
                            backgroundColor: '#5bc0de' // yellow
                        },
                        {
                            label: 'Retail',
                            data: [],
                            backgroundColor: '#d9534f' // red
                        }
                        ]
                    }                        
                    // count the number of valid entries
                    var counter = 0  
                    //update graph_data       
                    for (var margin of data.margins){                                                                        
                        //only show data where value is above minimum                        

                        var base_price = parseInt(margin.margins.base_price)                        
                        var wholesale_price = parseInt(margin.margins.wholesale)
                        var retail_price = parseInt(margin.margins.retail)                        
                        if (base_price == 0 && wholesale_price == 0 && retail_price == 0){                            
                            continue
                        }  

                        this_graph_data.labels.push(margin.product.name)
                                                
                        this_graph_data.datasets[0].data.push(margin.margins.base_price)
                        this_graph_data.datasets[1].data.push(margin.margins.wholesale)
                        this_graph_data.datasets[2].data.push(margin.margins.retail)

                        //calculate size of graph
                        counter += 1
                        if (counter > 100){
                            var width = counter * 25
                            this.graphStyling.width = String(`${width}px`)
                        }  
                    }
                    //push to graph data
                    this.graph_data.push({ "user":data.user, "data": this_graph_data})
                }
            }
        }
    },
    methods:{		
        //get_products
        getReport: function(){    
            this.getting_reports = true   
            this.reports = null     
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/user_margins/`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },
                params:{
                    date0: this.from_date,
                    date1: this.to_date
                }, 
            }).then((response)=>{
                this.getting_reports = false
                this.reports = response.data            
            }).catch((err)=>{
                this.getting_reports = false
                this.$emit('alert',err)
            })
        },   
        // get totals fro raw data 
        total: function(name){
            var total = 0
            if (this.user_raw_data){        
                for (var obj of this.user_raw_data.margins){                                            
                    total += parseInt(obj.margins[name])                    
                }                
            }    
            return total       
        }
    }
}
</script>
            